module.exports = __webpack_public_path__ + "s.no1.ad54b85c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/s.no1.jpg
// module id = Yc6y
// module chunks = 0